import React from "react";
import {
  FaWhatsappSquare,
  FaShareAlt,
  FaFacebookSquare,
  FaTwitterSquare,
  FaCopy,
} from "react-icons/fa";

import { connect } from "react-redux";
import { fixedAmount, percentageCoupon } from "../../helpers/icons";
import { languages } from "../../helpers/language";
import ReferralShareBtn from "./ReferralShareBtn";

const ReferFriend = ({
  customerData,
  merchantData,
  appStateData,
  referFriendRef,
}) => {
  let { customer } = customerData;
  let { merchant, currencySymbol } = merchantData;
  const { customerId, shopDomain } = appStateData;
  const isGermanLang = shopDomain === "nui-cosmetics.myshopify.com";

  let details = {
    main_referrals_desc:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.referrals_desc"
      ],
    main_referrals_button:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.referrals_button"
      ],

    redeem_fixed_coupon:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "redeem.percentage_coupon"
      ],

    referral_they_get:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "referral.they_get"
      ],
    referral_you_get:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "referral.you_get"
      ],
  };

  let referralLink = `${
    merchant?.referralLink !== undefined
      ? merchant?.referralLink
      : `https://${merchant?.myShopifyDomain}`
  }?ref=${customer?.referralCode}`;

  const handleMoreSharingOption = async () => {
    const shareData = {
      title: "Super Rewards",
      text: `Visit ${merchant.name} using my link and get a special coupon.`,
      url: referralLink,
    };
    try {
      await navigator.share(shareData);
    } catch (err) {
      console.log(err);
    }
  };

  function detectMob() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  return (
    <div ref={referFriendRef} className="referfriend-wrapper">
      <div className="referfriend-container-left">
        <div className="referfriend-heading-container">
          <h1 className="referfriend-heading">
            {merchant?.currentPlan?.planName !== "free" &&
            merchant?.customWidgetTheme?.textCustomization
              ? merchant?.customWidgetTheme?.textCustomization?.referYourFriends
              : details.main_referrals_button}
          </h1>
        </div>
      </div>
      <div className="referfriend-container-right">
        <div className="referfriend-details-container">
          <h2 className="referfriend-details-heading">
            {isGermanLang
              ? `Deine Freundin bekommt bekommt ${
                  merchant?.referralRewards?.friend?.rewardsType === "points"
                    ? `${merchant?.referralRewards?.friend?.points} ${
                        merchant?.pointsCurrency !== "Super-Points"
                          ? merchant?.pointsCurrency
                          : "Points"
                      }`
                    : `${
                        merchant?.friendType === "fixed_amount"
                          ? currencySymbol
                          : ""
                      }${merchant?.friendAmt}${
                        merchant?.friendType === "percentage" ? "%" : ""
                      }
          ${details.redeem_fixed_coupon.split("%")[1]}`
                } Rabatt, Du bekommst ${
                  merchant?.referralRewards?.advocate?.rewardsType === "points"
                    ? `${merchant?.referralRewards?.advocate?.points} ${
                        merchant?.pointsCurrency !== "Super-Points"
                          ? merchant?.pointsCurrency
                          : "Points"
                      }`
                    : `${
                        merchant?.advocateType === "fixed_amount"
                          ? currencySymbol
                          : ""
                      }${merchant?.advocateAmt}${
                        merchant?.advocateType === "percentage" ? "%" : ""
                      }
          ${details.redeem_fixed_coupon.split("%")[1]}`
                } Rabatt.`
              : merchant?.currentPlan?.planName !== "free" &&
                merchant?.customWidgetTheme?.textCustomization
              ? merchant?.customWidgetTheme?.textCustomization?.youGetTheyGet
              : `You Get 
            ${
              merchant?.referralRewards?.advocate?.rewardsType === "points"
                ? `${merchant?.referralRewards?.advocate?.points} ${
                    merchant?.pointsCurrency !== "Super-Points"
                      ? merchant?.pointsCurrency
                      : "Points"
                  }`
                : `${
                    merchant?.advocateType === "fixed_amount"
                      ? currencySymbol
                      : ""
                  }${merchant?.advocateAmt}${
                    merchant?.advocateType === "percentage" ? "%" : ""
                  }
        ${details.redeem_fixed_coupon.split("%")[1]}`
            }
            , They Get 
            ${
              merchant?.referralRewards?.friend?.rewardsType === "points"
                ? `${merchant?.referralRewards?.friend?.points} ${
                    merchant?.pointsCurrency !== "Super-Points"
                      ? merchant?.pointsCurrency
                      : "Points"
                  }`
                : `${
                    merchant?.friendType === "fixed_amount"
                      ? currencySymbol
                      : ""
                  }${merchant?.friendAmt}${
                    merchant?.friendType === "percentage" ? "%" : ""
                  }
        ${details.redeem_fixed_coupon.split("%")[1]}`
            }`}
          </h2>
          <p className="referfriend-details-subheading">
            {isGermanLang
              ? `Beschenke deine Lieblingsmenschen mit NUI. Sende deiner Freundin den
untenstehenden Link und sie erhält einen ${
                  merchant?.referralRewards?.friend?.rewardsType === "points"
                    ? `${merchant?.referralRewards?.friend?.points} ${
                        merchant?.pointsCurrency !== "Super-Points"
                          ? merchant?.pointsCurrency
                          : "Points"
                      }`
                    : `${
                        merchant?.friendType === "fixed_amount"
                          ? currencySymbol
                          : ""
                      }${merchant?.friendAmt}${
                        merchant?.friendType === "percentage" ? "%" : ""
                      }
${details.redeem_fixed_coupon.split("%")[1]}`
                } Gutschein. Wenn sie bei uns erfolgreich einkauft,
erhältst du ebenfalls ${
                  merchant?.referralRewards?.advocate?.rewardsType === "points"
                    ? `${merchant?.referralRewards?.advocate?.points} ${
                        merchant?.pointsCurrency !== "Super-Points"
                          ? merchant?.pointsCurrency
                          : "Points"
                      }`
                    : `${
                        merchant?.advocateType === "fixed_amount"
                          ? currencySymbol
                          : ""
                      }${merchant?.advocateAmt}${
                        merchant?.advocateType === "percentage" ? "%" : ""
                      }
${details.redeem_fixed_coupon.split("%")[1]}`
                } Rabatt für deine nächste Bestellung.`
              : merchant?.currentPlan?.planName !== "free" &&
                merchant?.customWidgetTheme?.textCustomization
              ? merchant?.customWidgetTheme?.textCustomization?.referDescription
              : `Give your friend ${
                  merchant?.referralRewards?.friend?.rewardsType === "points"
                    ? `${merchant?.referralRewards?.friend?.points} ${
                        merchant?.pointsCurrency !== "Super-Points"
                          ? merchant?.pointsCurrency
                          : "Points"
                      }`
                    : `${
                        merchant?.friendType === "fixed_amount"
                          ? currencySymbol
                          : ""
                      }${merchant?.friendAmt}${
                        merchant?.friendType === "percentage" ? "%" : ""
                      }
${details.redeem_fixed_coupon.split("%")[1]}`
                } off their first purchase. Get ${
                  merchant?.referralRewards?.advocate?.rewardsType === "points"
                    ? `${merchant?.referralRewards?.advocate?.points} ${
                        merchant?.pointsCurrency !== "Super-Points"
                          ? merchant?.pointsCurrency
                          : "Points"
                      }`
                    : `${
                        merchant?.advocateType === "fixed_amount"
                          ? currencySymbol
                          : ""
                      }${merchant?.advocateAmt}${
                        merchant?.advocateType === "percentage" ? "%" : ""
                      }
${details.redeem_fixed_coupon.split("%")[1]}`
                } when they make their first purchase.`}
          </p>
        </div>

        {/* share button */}
        {customerId && (
          <div className="refer-sharing-warpper">
            <div
              onClick={() =>
                navigator.clipboard.writeText(
                  `${
                    merchant?.referralLink !== undefined
                      ? merchant?.referralLink
                      : `https://${merchant?.myShopifyDomain}`
                  }?ref=${customer?.referralCode}`
                )
              }
              className="referral-link-container"
            >
              <input
                readOnly
                value={`${
                  merchant?.referralLink !== undefined
                    ? merchant?.referralLink
                    : `https://${merchant?.myShopifyDomain}`
                }?ref=${customer?.referralCode}`}
                className="referral-link-input"
              />
              {/* //copy to clipboard */}
              <button
                onClick={() =>
                  navigator.clipboard.writeText(
                    `${
                      merchant?.referralLink !== undefined
                        ? merchant?.referralLink
                        : `https://${merchant?.myShopifyDomain}`
                    }?ref=${customer?.referralCode}`
                  )
                }
                className="referral-link-copy-btn"
              >
                <FaCopy className="referral-link-copy-icon" />
              </button>
            </div>
            <div className="refer-sharing-option-wrapper">
              <ReferralShareBtn
                icon={
                  <FaFacebookSquare className="refer-sharing-item-btn-icon" />
                }
                text={
                  merchant?.currentPlan?.planName !== "free" &&
                  merchant?.customWidgetTheme?.textCustomization
                    ? merchant?.customWidgetTheme?.textCustomization?.facebook
                    : "Facebook"
                }
                sharingLink={`https://www.facebook.com/sharer/sharer.php?u=${referralLink}`}
              />
              <ReferralShareBtn
                icon={
                  <FaWhatsappSquare className="refer-sharing-item-btn-icon" />
                }
                text={
                  merchant?.currentPlan?.planName !== "free" &&
                  merchant?.customWidgetTheme?.textCustomization
                    ? merchant?.customWidgetTheme?.textCustomization?.whatsapp
                    : "Whatsapp"
                }
                sharingLink={`https://wa.me?text=Visit ${merchant.name} using my link and get a special coupon. ${referralLink}`}
              />

              {!detectMob() ? (
                <ReferralShareBtn
                  icon={
                    <FaTwitterSquare className="refer-sharing-item-btn-icon" />
                  }
                  text={
                    merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                      ? merchant?.customWidgetTheme?.textCustomization?.twitter
                      : "Twitter"
                  }
                  sharingLink={`https://twitter.com/share?ref_src=twsrc%5Etfw&url=${referralLink}&text=Visit ${merchant.name} using my link and get a special coupon. ${referralLink}`}
                />
              ) : (
                <ReferralShareBtn
                  icon={<FaShareAlt className="refer-sharing-item-btn-icon" />}
                  text="Share"
                  onClick={handleMoreSharingOption}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  customerData: state.CustomerReducer,
  merchantData: state.MerchantReducer,
  appStateData: state.AppstateReducer,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ReferFriend);
